import React from 'react';


export default function() {
    return <>
        <p>Inspired by <a href='https://www.youtube.com/watch?v=A7eJb8n8zAw'>Matt Parker’s recent video</a>, I decided to search for primes \(p\) with {'\\(\\tan{p} > p\\)'}, the first of which is the 46-digit</p>

        <p className='desktop'>
        \[p = 1169809367327212570704813632106852886389036911.\]
        </p>
        <p className='mobile'>
        \[p = 116980936732 \dots 886389036911.\]
        </p>

        <p>How do you go about finding more?</p>
        <p>Well, we want {'\\(\\tan{p}\\)'} to be big — <i>very</i> big.
        From high-school trigonometry, we know that this occurs when \(p\) is just a tiny bit less than a half-integer multiple of \(\pi\). In other words, we want
        </p>
    </>;
}
